<template>
	<div class="sdk_initaial">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">特征提取</h1>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			feature_extract接口提供了对图片进行人脸检测（只支持单个人脸），若有人脸并提取特征的功能。
		</p>
		<h3 class="doc_main_h3">调用URL</h3>
		<pre class="doc_main_pre"><code class="doc_main_code"><a href="https://skfrm.cn/APIV2/feature_extract">https://skfrm.cn/APIV2/feature_extract</a></code></pre>		
        <h3 class="doc_main_h3">请求参数</h3>
		<frm-Request-parameters :propsTableData="frmRequestParams"></frm-Request-parameters>
        <h3 class="doc_main_h3">返回值说明</h3>
		<frm-Return-value :propsTableData='frmReturnvalue'></frm-Return-value>
		<!-- <h3 class="doc_main_h3">通用错误码</h3>
		<frm-Error-Code :propsTableData='frmErrorCode'></frm-Error-Code> -->
		<h3 class="doc_main_h3">返回值示例</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">成功：
	{
		"error_code":"0",
		"error_msg":"success",
		"age":"40",
		"gender":"2",
		"yaw":9,
		"pitch":3,
		"location":{
        			"x1": "167",
        			"y1": "144",
        			"x2": "414",
        			"y2": "481"
    		},
		"image_url":"https://oss.skfrm.cn/Uploads/Register/Image/Original/2021-03-11/1615447654_5931_9wom29ezcce2d9e.jpg"
		"feature":"xpc4PzcKLcApAbq+JYAwwFMHpT//0vdAq0XjPm2gjL5MqK2/JYZrQO1A/2z+5v6A3PDyQXOM+6H/KPsC/iiObP8ECBcA=",
	}
失败：
	{
		"error_code":"5002",
		"error_msg":"未检测到人脸"
	}
</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	import AuthorityErrorCode from '../../../../components/authorityErrorCode';
	import FrmRequestParamsTable from'../../../../components/frmRequestParamsTable';
	import FrmReturnvalueTable from '../../../../components/frmReturnvalueTable';	
	import FrmErrorCodeTable from '../../../../components/frmErrorCodeTable';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
			'authority-error-code':AuthorityErrorCode,
			'frm-Request-parameters':FrmRequestParamsTable,		
			'frm-Return-value':FrmReturnvalueTable,
			'frm-Error-Code':FrmErrorCodeTable,
		},
		data(){
			return{
				isPathData:['FRM API-v2','人脸分析','特征提取'],			
				frmRequestParams:[
					{"require":"是","name":"account_id","type":"int","msg":"当前账号id"},
					{"require":"是","name":"token","type":"string","msg":"当前账号登录后返回的token"},
					{"require":"是","name":"project_id","type":"int","msg":"项目id"},
					{"require":"是","name":"image","type":"string","msg":"Base64后的图片数据（例如：/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAMCAgICAgMCAgIDAwMDBAYEBAQEBAgGBgUGCQgKCgkICQkKDA8MCgsOCwkJDRENDg8QEBEQCgwgenderIQEw8QEBD/2wBDA）"},
					{"require":"是","name":"mode_version","type":"string","msg":"模型版本号"},
				],
				frmReturnvalue:[
					{"Parameter":"error_code","name":"string","msg":"0 成功  1 失败"},
					{"Parameter":"error_msg","name":"string","msg":"成功返回 success  失败返回 fail"},
					{"Parameter":"age","name":"string","msg":"如果图片有人脸，则返回对人脸的年龄预测值"},
					{"Parameter":"gender","name":"string","msg":"如果图片有人脸，则返回对人脸的性别预测值，1 女 2 男"},
					{"Parameter":"yaw","name":"string","msg":"人脸姿态：偏航角"},
					{"Parameter":"pitch","name":"string","msg":"人脸姿态：俯仰角"},
					{"Parameter":"location","name":"string","msg":"人脸坐标(左上角点坐标: x1,y1;右下角点坐标: x2,y2)"},
					{"Parameter":"image_url","name":"string","msg":"如果图片有人脸，则返回所截取大头照的url"},
					{"Parameter":"feature","name":"string","msg":"如果图片有人脸，则返回所提取的人脸特征"},
				],
				frmErrorCode:[
					{"Statuscode":"4001","errormessage":"未在照片中检测到人脸","msg":"未在照片中检测到人脸"},
					{"Statuscode":"4002","errormessage":"未在照片中检测到人脸","msg":"未在照片中检测到人脸"},
					{"Statuscode":"4003","errormessage":"照片质量差，请更换照片","msg":"照片质量差，请更换照片"},
					{"Statuscode":"4004","errormessage":"服务器异常，请稍后重试","msg":"服务器异常，请稍后重试"},
					{"Statuscode":"4005","errormessage":"服务器异常，请稍后重试","msg":"服务器异常，请稍后重试"},
					{"Statuscode":"4006","errormessage":"服务器异常，请稍后重试","msg":"服务器异常，请稍后重试"},
					{"Statuscode":"4007","errormessage":"不合格式的照片","msg":"支持jpg、png格式的图片"},
					{"Statuscode":"4008","errormessage":"服务器繁忙，请稍后重试","msg":"服务器繁忙，请稍后重试"},
					{"Statuscode":"4009","errormessage":"服务器异常，请稍后重试","msg":"服务器异常，请稍后重试"},
					{"Statuscode":"4010","errormessage":"人脸不完整，请更换照片上传","msg":"人脸不完整，请更换照片上传"},
					{"Statuscode":"4011","errormessage":"包含多张人脸，请更换照片上传","msg":"包含多张人脸，请更换照片上传"},
					{"Statuscode":"4012","errormessage":"注册图片中人脸比例太小，请更换注册图片","msg":"注册图片中人脸比例太小，请更换注册图片"},
					{"Statuscode":"4013","errormessage":"人脸模糊，请更换注册图片","msg":"人脸模糊，请更换注册图片"},
					{"Statuscode":"4014","errormessage":"检测到戴墨镜，请更换图片","msg":"检测到戴墨镜，请更换图片"},
					{"Statuscode":"4015","errormessage":"图片尺寸过大，请更换注册图片","msg":"图片尺寸过大，请更换注册图片"},
					{"Statuscode":"4016","errormessage":"检测到戴口罩","msg":"检测到戴口罩"},
					{"Statuscode":"4017","errormessage":"人脸姿态不合格","msg":"人脸姿态不合格"},
					{"Statuscode":"4018","errormessage":"检测到遮挡","msg":"检测到遮挡"},
					{"Statuscode":"4019","errormessage":"服务器异常，请稍后重试","msg":"服务器异常，请稍后重试"},
					{"Statuscode":"9001","errormessage":"token无效","msg":"token过期"},
					{"Statuscode":"9002","errormessage":"project_id无效","msg":"项目id无效"},
				],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.sdk_initaial{
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/FRMAPIVTOW/Facerecognition/Feature_extract.vue